"use client";

import React from 'react'
import dynamic from 'next/dynamic';
import Sites from 'src/constants/Sites';
import CatalogHome from '@components/HomePage/CatalogHome';
import ContentHome from '@components/HomePage/ContentHome';

const EBBHomepageV2 = dynamic(() => import("@components/HomePage/EBBHomepageV2"), { ssr: true });

import styles from "./IndexPage.module.css";

function IndexPage(props) {
  const classes = {
    "HomePageSection": styles["HomePageSection"],
    "PromoRibbon-instructional": styles["PromoRibbon-instructional"],
    "promoItem": styles["promoItem"],
    "promoImage": styles["promoImage"],
    "instructional": styles["instructional"],
    "PromoRibbon-retailer": styles["PromoRibbon-retailer"],
    "grid-item": styles["grid-item"],
    "large-2": styles["large-2"],
    "promo-subheader": styles["promo-subheader"],
    "contentHomepage": styles["contentHomepage"],
    "v-card-img-top": styles["v-card-img-top"],
    "h-card": styles["h-card"],
    "h-card-details": styles["h-card-details"],
  }
  props = {...props, classes};
  
  
  return (
    <>
      {
        props.siteId === Sites.OPENROADMEDIA ? (
          <CatalogHome HomeData={props} />
        ) : props.siteId === Sites.EARLYBIRDBOOKS ? (
          <EBBHomepageV2 HomeData={props} />
        ) : (
          <ContentHome HomeData={props} />
        )
      }
    </>
  )
}

export default IndexPage